import { styled, alpha } from "@mui/material/styles";
import { Box, Grid, Stack, Container, Typography, Button } from "@mui/material";
import { bgGradient } from "../../utils/cssStyles";
import useStyles from "../home/styles/styles";
import Shape from "../home/components/Shape";
import { useState } from "react";
import { useMutation } from "react-query";
import http from "../../services/http-common";
// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  ...bgGradient({
    color: alpha(theme.palette.background.default, 0.9),
    imgUrl: "https://zone-ui.vercel.app/assets/background/overlay_1.jpg",
  }),
  position: "relative",
  overflow: "hidden",
  // [theme.breakpoints.up("md")]: {
  //   height: `calc(100vh - ${HEADER.H_MAIN_DESKTOP}px)`,
  // },
}));
const clases = {
  header1: {
    fontSize: {
      xs: "8.9vw !important",
      md: "3.38vw !important",
    },
    fontWeight: "600 !important",
    // letterSpacing: "-1.33px !important",
  },
  header2: {
    fontSize: {
      xs: "6.5vw !important",
      md: "2.5vw !important",
    },
    fontWeight: "550 !important",
    // letterSpacing: "-1.0px !important",
  },
  header3: {
    fontSize: { xs: "7.5vw", md: "2.6vw !important" },
    fontWeight: "600 !important",
    color: "#101010 !important",
  },
  header4: {
    fontSize: { xs: "5.5vw !important", md: "1.5vw !important" },
    fontWeight: "600 !important",
    color: "#333333 !important",
    textAlign: { xs: "center", md: "left" },
  },
  contentText: {
    fontSize: { xs: "4.07vw !important", md: "1.15vw !important" },
    fontWeight: "500 !important",
    color: "#757B8A !important",
    textAlign: { xs: "center", md: "left" },
  },
  buttonSx: {
    width: { md: "22.48vw", xs: "39.95vw" },
    fontSize: { xs: "3.56vw", md: "1.11vw" },
    paddingY: { xs: "5vw", md: "1.5vw" },
  },
};

export default function HomeSection() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const navigate = (url: any) => (window.location.href = url);

  const handleBuy = (id: any, isRecurring: any) => {
    setLoading(true);
    buyProduct.mutate({ id, isRecurring });
  };

  const buyProduct = useMutation(
    (data: any) => {
      return http.post(
        `stripe/create-checkout-session`,
        {
          priceId: "price_1RCKxvHa0zoJgb0fOIrHaZE2",
          isRecurring: data.isRecurring,
          successUrl: `${window.location.href}success`,
          cancelUrl: `${window.location.origin}/cancel`,
        },
        null
      );
    },
    {
      onSuccess: ({ data }: any) => {
        navigate(data.url);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  return (
    <>
      <StyledRoot
        sx={{
          height: 1,
          background: {
            xs: "linear-gradient(180deg, #F6F8FD 0%, #FFFFFF 100%)",
            md: "linear-gradient(180deg, #F7F9FF 11.26%, #FFFFFF 99.96%)",
          },
        }}
      >
        <Shape secNumber="1" justifyContent="end" />
        <Container id="home">
          <Stack
            spacing={2}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              py: 15,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography sx={clases.header1}>
              <Box component="span" sx={{ color: "primary.main" }}>
                {` Shop`}
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: "text.secondary",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Welcome to the Entheology Project Shop!
            </Typography>
          </Stack>
        </Container>
      </StyledRoot>
      <Grid
        className={classes.sectionBox}
        id="gptStore"
        sx={{ background: "#ffffff" }}
      >
        <Shape secNumber="6" />

        <Grid
          container
          className={classes.containerGrid}
          sx={{
            paddingBottom: "2vw",
            pt: { xs: "17.3vw", md: "3.07vw" },
          }}
        >
          <Grid item className={classes.flexCenter} xs={11} md={12}>
            <Typography sx={clases.header2}>
              EntheoDNA – At Home Entheogenic Sensitivity Kit
            </Typography>
          </Grid>
          <Box
            className={classes.flexCenter}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              flexWrap: "no-wrap",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "stretch",
            }}
          >
            <Grid
              item
              xs={11}
              md={3.5}
              className={classes.flexCenter}
              sx={{ my: { xs: "15.26vw", md: "0" } }}
              alignSelf={"baseline"}
            >
              <Box
                component="img"
                src="https://entheo.info/wp-content/uploads/2024/06/entheodna-entheogenic-sensitivity-kit-box-1.png"
                alt="logo"
                className={classes.image}
              />
            </Grid>
            <Grid item md={1}></Grid>
            <Grid item xs={11} md={4.7}>
              <Typography variant="h5" sx={clases.header4}>
                Unlock the Power of Your Genetics with EntheoDNA
              </Typography>
              <Box>
                <Typography sx={clases.contentText}>
                  Discover how your unique genetic profile influences your
                  response to entheogens like Psilocybin, MDMA, Ayahuasca, and
                  more. Powered by Dynamic DNA Labs, EntheoDNA provides
                  comprehensive insights into your genetic predispositions,
                  helping you optimize your psychedelic experiences for safety
                  and efficacy.
                </Typography>
              </Box>
              <Box>
                <Typography variant="h5" sx={clases.header4} className="mb-0">
                  Key Features:
                </Typography>
                <ul className="list-disc px-3">
                  <li className="!mb-0">
                    <Typography sx={clases.contentText} className="!mb-1">
                      <span className="font-bold"> Personalized Therapy:</span>{" "}
                      Tailor your psychedelic experiences based on genetic data.
                    </Typography>
                  </li>
                  <li>
                    <Typography sx={clases.contentText} className="!mb-1">
                      <span className="font-bold">Comprehensive Testing:</span>{" "}
                      Analyze key genetic markers related to metabolism,
                      receptor sensitivity, and potential adverse reactions.
                    </Typography>
                  </li>
                  <li>
                    <Typography sx={clases.contentText} className="!mb-1">
                      <span className="font-bold">Expert Interpretation:</span>{" "}
                      Receive in-depth reports that combine cutting-edge genetic
                      analysis with expert insights.
                    </Typography>
                  </li>
                </ul>
              </Box>
              <Box>
                <Typography variant="h5" sx={clases.header4} className="mb-0">
                  What We Test:
                </Typography>
                <ul className="list-disc px-3">
                  {[
                    { name: "MDMA", markers: "SLC6A2, CYP2D6, CYP3A4" },
                    { name: "Psilocybin", markers: "HTR2A" },
                    { name: "DMT", markers: "CYP2D6, MAO-A, HTR1A" },
                    { name: "Mescaline", markers: "CYP2D6, HTR2A" },
                    { name: "Ketamine", markers: "BDNF, CYP2B6, CYP2C9" },
                    { name: "Ibogaine", markers: "CYP2D6, ABCB1, ABCG2" },
                    { name: "LSD", markers: "CYP2D6" },
                    { name: "Salvia", markers: "OPRK1" },
                    { name: "Cannabis", markers: "AKT1, CYP2C9, CYP3A4" },
                  ].map((substance, index) => (
                    <li key={index} className="!mb-0">
                      <Typography sx={clases.contentText} className="!mb-1">
                        <span className="font-bold">{substance.name}:</span>{" "}
                        {substance.markers}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            </Grid>{" "}
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        className={classes.sectionBox}
        sx={{ background: "#ffffff" }}
      >
        <Shape secNumber="5" />

        <>
          <Box
            className={classes.shapeBox}
            sx={{
              display: { xs: "flex", md: "none", flexDirection: "column" },
              width: "100%",
            }}
          >
            <Box
              component="img"
              src="https://entheo.info/wp-content/uploads/2024/06/entheodna-entheogenic-sensitivity-kit-box-1.png"
              alt="logo"
              sx={{
                width: "100%",
              }}
            />
          </Box>
        </>
        <Grid container className={classes.containerGrid} sx={{ pb: "3.1" }}>
          <Grid item md={0.3}></Grid>
          <Grid item xs={11} md={4.7}>
            <Typography variant="h5" sx={clases.header4}>
              Comprehensive DNA Report
            </Typography>

            <Box>
              <Typography sx={clases.contentText}>
                The EntheoDNA kit includes a detailed, personalized report that
                synthesizes your genetic data with expert insights provided by
                Dynamic DNA Labs. This report focuses on key genetic markers
                related to the metabolism, efficacy, and potential risks
                associated with various entheogens. It’s not just about
                identifying your genetic predispositions but about providing
                actionable recommendations tailored to your unique profile.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h5" sx={clases.header4} className="mb-0">
                Benefits:
              </Typography>
              <ul className="list-disc px-3">
                {[
                  {
                    name: "Harm Reduction",
                    desc: "Minimize risks by understanding how your body interacts with psychedelics at the genetic level.",
                  },
                  {
                    name: "Optimized Efficacy",
                    desc: "Enhance the effectiveness of your experiences by aligning them with your genetic predispositions.",
                  },
                  {
                    name: "Predictable Outcomes",
                    desc: "Gain peace of mind by knowing how you are likely to respond to different substances.",
                  },
                ].map((substance, index) => (
                  <li key={index} className="!mb-0">
                    <Typography sx={clases.contentText} className="!mb-1">
                      <span className="font-bold">{substance.name}:</span>{" "}
                      {substance.desc}
                    </Typography>
                  </li>
                ))}
              </ul>
              <Box>
                <Typography sx={clases.contentText} className="!mt-2">
                  <span className="font-bold">Order Your Kit Today</span> and
                  take the first step towards a safer, more personalized
                  psychedelic experience.
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={11}
            md={4.5}
            className={classes.flexCenter}
            sx={{ width: "100%", minHeight: "45vw" }}
          >
            <Grid
              item
              md={1}
              sx={{ display: { xs: "none", md: "flex" } }}
            ></Grid>

            <Grid
              item
              xs={12}
              sx={{
                // display: { md: 'none', xs: 'flex' },
                display: "flex",
                height: {
                  sm: "30vw",
                  xs: "auto",
                },
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <EmbededBot /> */}

              <Box
                component="img"
                src="https://entheo.info/wp-content/uploads/2024/06/Branded-DNA-Kit.png"
                alt="logo"
                className={classes.image}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid className={classes.sectionBox} sx={{ background: "#f7f9ff" }}>
        <Shape secNumber="1" />
        <Grid
          item
          container
          xs={12}
          md={12}
          className={classes.flexCenter}
          sx={{
            flexDirection: "column",
            py: { xs: "15.77vw", md: "3vw" },
          }}
        >
          <Typography sx={clases.header2}>How It Works</Typography>
          <Grid
            item
            xs={11}
            md={8.7}
            className={classes.flexCenter}
            sx={{
              flexDirection: "column",
            }}
          >
            <Grid item xs={11} md={10}>
              <ul className="list-decimal px-3">
                <li>
                  <Typography sx={clases.contentText}>
                    <span className="font-bold">Order:</span> Easily purchase
                    your EntheoDNA kit online. Your kit arrives in 3-5 business
                    days.
                  </Typography>
                </li>
                <li>
                  <Typography sx={clases.contentText}>
                    <span className="font-bold">Collect:</span> Follow the
                    simple instructions and video guide to provide a cheek swab
                    sample.
                  </Typography>
                </li>
                <li>
                  <Typography sx={clases.contentText}>
                    <span className="font-bold">Send:</span> Use the prepaid
                    label to send your sample to Dynamic Labs.
                  </Typography>
                </li>
                <li>
                  <Typography sx={clases.contentText}>
                    <span className="font-bold">Discover:</span> Receive your
                    personalized report with unique genetic insights and
                    recommendations within a few weeks.
                  </Typography>
                </li>
                <li>
                  <Typography sx={clases.contentText}>
                    <span className="font-bold">Empower:</span> Consult with a
                    healthcare professional to discuss your results and create a
                    personalized plan.
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid className={classes.sectionBox} sx={{ background: "#f7f9ff" }}>
        <Shape secNumber="2" />
        <Grid
          item
          container
          xs={12}
          md={12}
          className={classes.flexCenter}
          sx={{
            flexDirection: "column",
            py: { xs: "15.77vw", md: "3vw" },
          }}
        >
          <Typography sx={clases.header2}>Kit Components</Typography>
          <Grid
            item
            xs={11}
            md={8.7}
            className={classes.flexCenter}
            sx={{
              flexDirection: "column",
            }}
          >
            <Grid item xs={11} md={10}>
              <ul className="list-decimal px-3">
                {[
                  {
                    title: "Informed Consent Form (electronically sent)",
                    description:
                      "Ensure you understand and agree to the testing terms.",
                  },
                  {
                    title: "DNA Collection Kit",
                    description:
                      "Contains two buccal swabs for cheek cell collection.",
                  },
                  {
                    title: "Collection Envelope",
                    description:
                      "For securely storing your swabs and desiccant pack.",
                  },
                  {
                    title: "Instruction Card",
                    description:
                      "Step-by-step guide to help you complete your sample collection.",
                  },
                  {
                    title: "Prepaid Return Mailer",
                    description:
                      "For easy and secure shipment of your sample to the lab.",
                  },
                  {
                    title: "Kit Card",
                    description:
                      "Contains your unique kit ID for tracking your sample and results.",
                  },
                ].map((item, index) => (
                  <li key={index}>
                    <Typography sx={clases.contentText}>
                      <span className="font-bold">{item.title}:</span>{" "}
                      {item.description}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        className={classes.sectionBox}
        sx={{ background: "#F7F9FF" }}
      >
        <Shape secNumber="3" />
        <Grid
          container
          className={classes.containerGrid}
          sx={{ py: { xs: "16.03vw", md: "3vw" } }}
        >
          <Grid item className={classes.flexCenter} xs={11} md={12}>
            <div className="flex flex-col justify-center items-center">
              <Typography className=" mt-2" sx={clases.header2}>
                Embrace Your Individuality and Support Research
              </Typography>
            </div>
          </Grid>
          <Container>
            <Grid
              item
              className={classes.flexCenter}
              sx={{
                display: "flex",
                flexDirection: { xs: "column-reverse", md: "row" },
              }}
            >
              <Grid item>
                <Box>
                  <Typography sx={clases.contentText} textAlign={"center"}>
                    EntheoDNA isn’t just about genetics; it’s about embracing
                    your individuality and empowering your wellness journey. By
                    purchasing EntheoDNA, you’re also contributing to further
                    entheogenic research, paving the way for new discoveries and
                    personalized wellness solutions.
                  </Typography>
                  <Typography sx={clases.contentText} textAlign={"center"}>
                    <span className="font-bold">Disclaimer:</span> The EntheoDNA
                    by Dynamic Labs is not a substitute for professional medical
                    or psychological advice. Always consult with a qualified
                    healthcare provider before making any decisions related to
                    entheogenic use.{" "}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
      <Grid className={classes.sectionBox}>
        <Shape secNumber="4" />
        <Grid
          item
          container
          xs={12}
          md={12}
          className={classes.flexCenter}
          sx={{
            flexDirection: "column",
            py: { xs: "15.77vw", md: "3vw" },
          }}
        >
          <Typography sx={clases.header3} className="!text-center">
            💡 Want <span>EntheoDNA</span> kit?
          </Typography>
          <Grid
            item
            xs={11}
            md={8.7}
            className={classes.flexCenter}
            sx={{
              flexDirection: "column",
            }}
          >
            <Box
              className={classes.flexCenter}
              sx={{
                gap: "2vw",
                p: { md: "1vw", xs: "5vw" },
              }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={clases.buttonSx}
                onClick={() => handleBuy("prod_S6Y4LM9gIXqt53", "no")}
              >
                Order Now
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
